import { render, staticRenderFns } from "./AuthenticatedLayout.vue?vue&type=template&id=4ef23127&scoped=true&"
import script from "./AuthenticatedLayout.vue?vue&type=script&lang=ts&"
export * from "./AuthenticatedLayout.vue?vue&type=script&lang=ts&"
import style0 from "./AuthenticatedLayout.vue?vue&type=style&index=0&id=4ef23127&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef23127",
  null
  
)

export default component.exports